/**
 * 赠送弹框
 */

import * as React from 'react'
import dayjs from 'dayjs'
import { useModalWrap } from '@/components'
import { getLoginStatus } from '@/utils'
import {
  setUserStorage,
  getUserStorage,
  setCompanyStorage,
  getCompanyStorage,
} from '@/services/common'
import Content from './Content'
import styles from './index.module.less'

const { useEffect } = React

/**
 * 企业领取记录标识
 */
const teamGiftNoticeKey: string = 'gift-notice-flag'
// 个人领取记录标识
const personalGiftNoticeKey: string = 'personal-gift-notice'
// 个人领取弹框关闭标识
const personalGiftNoticeDate: string = 'gift-notice-close-date'

export default function Index({ isPersonal, userInfo, memberReceiveShow }: any) {
  /**
   * 关闭弹框
   */
  const handleClose = () => {
    if (isPersonal) {
      setUserStorage({
        key: personalGiftNoticeDate,
        value: dayjs().format('YYYY-MM-DD HH:mm:ss'),
      })
    } else {
      setCompanyStorage({
        key: teamGiftNoticeKey,
        value: '1',
      })
    }
  }

  /**
   * 个人领取或不在提示
   */
  const handleOk = () => {
    setUserStorage({
      key: personalGiftNoticeKey,
      value: '1',
    })
  }

  const { showModal, render } = useModalWrap({
    modalProps: {
      title: null,
      width: 500,
      bodyStyle: { padding: 0 },
      footer: null,
      maskClosable: false,
      className: styles.modalWrap,
      afterClose: handleClose,
    },
    children: ({ form, hideModal }: any) => (
      <Content form={form} isPersonal={isPersonal} onClose={hideModal} onOk={handleOk} />
    ),
  })

  useEffect(() => {
    async function init(mr: number) {
      if (isPersonal) {
        const memberLevel: any = !!userInfo?.memberLevel
        // 没有领会员或会员弹框正在打开
        if (!memberLevel || mr === 1) return
        // 已填写企业名称
        if (userInfo.isBindCompanyName) return
        const { data } = await getUserStorage({
          keys: [personalGiftNoticeKey, personalGiftNoticeDate],
        })
        if (data?.code === 0) {
          const result: any = data?.result || {}
          const isGiftReceive: any = result?.[personalGiftNoticeKey]
          // 点击了不再提示
          if (!!isGiftReceive) return
          // 未填写定企业名称或没有点击过不再提示按钮
          const lastDate: string = result[personalGiftNoticeDate]
          if (!lastDate) {
            // 没有上一次弹框时间，是首次弹框
            showModal()
          } else {
            const nextNoticeDateStamp = dayjs(lastDate).add(3, 'day').valueOf()
            if (dayjs().valueOf() > nextNoticeDateStamp) {
              // 关闭弹框，三天后继续提醒
              showModal()
            }
          }
        }
      } else {
        const { data } = await getCompanyStorage({
          keys: [teamGiftNoticeKey],
        })
        if (data?.code === 0) {
          const result = data?.result?.[teamGiftNoticeKey]
          if (!result) {
            showModal()
          }
        }
      }
    }
    if (getLoginStatus() && userInfo) {
      if (!userInfo.isBindSSO) {
        // 非sso用户弹框
        setTimeout(() => init(memberReceiveShow), 2000)
      }
    }
  }, [isPersonal, userInfo, memberReceiveShow])

  return <>{render()}</>
}
